export const confirmEmail = async function confirmEmail() {
    // Review r3 D5: the confirm runs on the page's Continue click, never on
    // load (a mail scanner that runs JS would otherwise confirm, run the
    // cleanup and take the fresh session).
    this.state.update({ awaitingContinue: false, loading: true, error: null })
    try {
      const params = new URLSearchParams(window.location.search)
      const token = params.get('token')
      // The `email` param is display-only and attacker-writable (review r4
      // N2): the page names the address from the server
      // (previewConfirmation). It stays required as the mark of an emailed
      // verify link: an invitation's `?token=` carries no `email`.
      const email = params.get('email')

      if (!token || !email) {
        throw new Error('Invalid confirmation link')
      }

      const result = await this.sdk.confirmRegistration(token)
      // A first proof of the address from a browser with no session for this
      // account (e.g. a demo claim's link opened on another device) makes the
      // server drop the password set before the proof and answer with a fresh
      // session in `result.tokens`. Adopt it through the SDK's TokenManager
      // (an SDK that already adopted it is skipped) and boot signed in —
      // otherwise the user has no password and no session.
      const tokens = result?.tokens
      const tm = this.sdk?._tokenManager
      if (tokens?.accessToken && tm?.setTokens) {
        if (tm.getAccessToken?.() !== tokens.accessToken) {
          tm.setTokens({
            access_token: tokens.accessToken,
            refresh_token: tokens.refreshToken,
            expires_in: tokens.accessTokenExp?.expiresIn,
            token_type: 'Bearer'
          })
        }
        // The adopted refresh token is this origin's own (review D1): every
        // sign-in that stores a refresh token marks it.
        this.call('markOwnSession')
        // Review r3 D4: the cleanup dropped the pre-set password and the
        // answer carries a single-use setPasswordToken — stay on the page and
        // ask for a password (or Skip); completeConfirmSignIn re-boots.
        if (result?.setPasswordToken) {
          this.state.update({
            loading: false,
            success: true,
            signedIn: true,
            error: null,
            setPasswordToken: result.setPasswordToken
          })
          return
        }
        this.state.update({ loading: true, success: true, signedIn: true, error: null })
        // frank-allow FA401 — auth hard reset: boot re-derives the session from the adopted tokens (spaReloadCensus class b)
        window.location.replace('/')
        return
      }
      if (result) {
        // A sign-in on this origin: its refresh token is its own (review D1).
        this.call('markOwnSession')
        this.state.update({
          loading: false,
          success: true
        })
      } else {
        throw new Error('Confirmation failed')
      }
    } catch (error) {
      // 409 "Email taken": a pending email (demo claim) that another account
      // took before the link was clicked. The server burns the token, so a
      // retry cannot succeed — flag it for a dedicated message.
      const http = error?.cause || error
      if (http?.status === 409 || http?.cause?.error === 'Email taken') {
        this.state.update({ loading: false, success: false, emailTaken: true, error: null })
        return
      }
      this.state.update({
        loading: false,
        success: false,
        error: error.message
      })
    }
  }